module.exports = __webpack_public_path__ + "static/media/white-overlay.1d4128fa.png";